import { css } from 'styled-components';

export const FlexAlignRight = css`
  display: flex;
  justify-content: flex-end;
`;

export const FlexNoAlign = css`
  display: flex;
`;

export const FlexAlignCenter = css`
  display: flex;
  align-items: center;
`;

export const FlexJustifyCenter = css`
  display: flex;
  justify-content: center;
`;

export const FlexJustifyBetween = css`
  display: flex;
  justify-content: space-between;
`;

export const FlexJustifyAround = css`
  display: flex;
  justify-content: space-around;
`;

export const FlexColumn = css`
  display: flex;
  flex-direction: column;
`;
